import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface OtherLiabilitiesInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function OtherLiabilitiesInternalControls({ onBack, setActiveSection, controlsListSection }: OtherLiabilitiesInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Other Liabilities"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
